import { render } from "./GenerateNFUpdate.vue?vue&type=template&id=21a777db&scoped=true"
import script from "./GenerateNFUpdate.vue?vue&type=script&lang=js"
export * from "./GenerateNFUpdate.vue?vue&type=script&lang=js"

import "./GenerateNFUpdate.vue?vue&type=style&index=0&id=21a777db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a777db"]])

export default __exports__